import { render } from "./test3.vue?vue&type=template&id=f9bab772&scoped=true"
import script from "./test3.vue?vue&type=script&lang=js"
export * from "./test3.vue?vue&type=script&lang=js"

import "./test3.vue?vue&type=style&index=0&id=f9bab772&scoped=true&lang=css"

import exportComponent from "C:\\MyFile\\codeVue\\xb-notes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bab772"]])

export default __exports__